import { useRef } from 'react';
import { CommonInput } from '../CreateNewCharacter/useDetailInput';

interface useDirectionInputProps {
  setInput: React.Dispatch<React.SetStateAction<CommonInput>>;
}

const useDirectionInput = ({ setInput }: useDirectionInputProps) => {
  const textRef = useRef<HTMLTextAreaElement>(null);

  const handleDirectionClick = () => {
    if (textRef.current) {
      const startPosition = textRef.current.selectionStart;
      const endPosition = textRef.current.selectionEnd;

      const beforeText = textRef.current.value.substring(startPosition, 0);
      const draggedText = textRef.current.value.substring(
        startPosition,
        endPosition,
      );
      const afterText = textRef.current.value.substring(endPosition);
      const value = beforeText + '*direction:' + draggedText + '*' + afterText;

      textRef.current.value = value;
      setInput((prev) => ({
        ...prev,
        opening: value,
      }));
      textRef.current.focus();
      textRef.current.setSelectionRange(endPosition + 11, endPosition + 11);
    }
  };

  const handleUserNameClick = () => {
    if (textRef.current) {
      const startPosition = textRef.current.selectionStart;

      const beforeText = textRef.current.value.substring(startPosition, 0);
      const afterText = textRef.current.value.substring(startPosition);
      const value = beforeText + '{{user}}' + afterText;

      textRef.current.value = value;
      setInput((prev) => ({
        ...prev,
        opening: value,
      }));
      textRef.current.focus();
      textRef.current.setSelectionRange(startPosition + 8, startPosition + 8);
    }
  };

  return {
    textRef,
    handleDirectionClick,
    handleUserNameClick,
  };
};

export default useDirectionInput;
